import React from 'react';
import { StanAccordionProps } from './StanAccordion.types';
import { AccordionContext } from './StanAccordion.context';
import { useAccordionController } from '@/hooks/useAccordionController';

export const StanAccordion: React.FC<StanAccordionProps> = ({
    children,
    allowMultipleOpen = false,
    className = '',
    controller,
}) => {
    const internalController = useAccordionController(allowMultipleOpen);
    const contextValue = controller || internalController;

    return (
        <AccordionContext.Provider value={contextValue}>
            <div className={className}>{children}</div>
        </AccordionContext.Provider>
    );
};
